import React from 'react';
import FormContainer from '../components/common/FormContainer';
import LoginForm from '../components/forms/LoginForm';

const Login = () => {
    return (
        <FormContainer>
            <LoginForm />
        </FormContainer>
    );
};

export default Login;
